// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nPmUWLLoW7WsD7WwFK4d .g54oZb38l4Ofmi8c03MT{display:flex;align-items:center}.nPmUWLLoW7WsD7WwFK4d .guJHwqj5iQaa48mUcO_A{margin:0 auto}.nPmUWLLoW7WsD7WwFK4d .mD7cXtWnJcw017svLxex{margin-top:20px}.nPmUWLLoW7WsD7WwFK4d .LtwkQHH2M07uidmyAq0A{margin-top:10px}.nPmUWLLoW7WsD7WwFK4d .Vs4ALwWTapg1EUVAUw8H{margin-top:10px}.nPmUWLLoW7WsD7WwFK4d .Vs4ALwWTapg1EUVAUw8H:first-child{margin-top:0}`, "",{"version":3,"sources":["webpack://./src/Pages/Breadcrumbs/components/Breadcrumbs/Breadcrumbs.styl"],"names":[],"mappings":"AAGI,4CACI,YAAS,CACT,kBAAa,CAEjB,4CACI,aAAQ,CAEZ,4CACI,eAAY,CAEhB,4CACI,eAAY,CAEhB,4CACI,eAAY,CAEZ,wDACI,YAAY","sourcesContent":["@import '~assets/stylus/config/colors'\n\n.main\n    .info\n        display: flex;\n        align-items: center;\n\n    .wrapper\n        margin: 0 auto;\n\n    .paginatorWrapper\n        margin-top: 20px;\n\n    .breadcrumbList\n        margin-top: 10px;\n\n    .requestWrapper\n        margin-top: 10px;\n\n        &:first-child\n            margin-top: 0;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"textColor": `#404041`,
	"colorRed": `#dd4e44`,
	"colorPink": `#ff1493`,
	"colorBlue": `#24b2e0`,
	"colorGreen": `#65c178`,
	"colorOrange": `#fa9961`,
	"colorYellow": `#e09f34`,
	"colorPurple": `#5841ab`,
	"colorDarkBlue": `#223c75`,
	"colorBrightBlue": `#3398d9`,
	"colorGoogle": `#4285f4`,
	"main": `nPmUWLLoW7WsD7WwFK4d`,
	"info": `g54oZb38l4Ofmi8c03MT`,
	"wrapper": `guJHwqj5iQaa48mUcO_A`,
	"paginatorWrapper": `mD7cXtWnJcw017svLxex`,
	"breadcrumbList": `LtwkQHH2M07uidmyAq0A`,
	"requestWrapper": `Vs4ALwWTapg1EUVAUw8H`
};
export default ___CSS_LOADER_EXPORT___;
